import { Search, X } from "lucide-react";
import { useState } from "react";

import { Input } from "../../Components/Global/UI/Input";
import { useGeoapifySearch } from "../../hooks/useGeoapifySearch";

export function MapboxSearchBox({ value, onChange, onPlaceSelect }) {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const { suggestions, loading } = useGeoapifySearch(value);

  const handleSelect = (suggestion) => {
    const fullAddress =
      suggestion.properties.formatted ||
      suggestion.properties.address_line1 ||
      suggestion.properties.name;

    onChange(fullAddress);
    onPlaceSelect?.(suggestion);
    setShowSuggestions(false);
  };

  const handleClear = () => {
    onChange("");
    setShowSuggestions(false);
  };

  const handleInputChange = (e) => {
    onChange(e.target.value);
    setShowSuggestions(true);
  };

  return (
    <div className="relative">
      {/* Input with icons */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
        {value && (
          <button
            onClick={handleClear}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
          >
            <X className="w-4 h-4" />
          </button>
        )}
        <Input
          className="pl-9 pr-9"
          value={value}
          onChange={handleInputChange}
          placeholder="Search for place or address..."
        />
      </div>

      {/* Suggestions dropdown */}
      {value && showSuggestions && suggestions.length > 0 && (
        <div className="absolute z-10 mt-1 w-full bg-white shadow-md border border-dotted border-gray-300 rounded-md overflow-hidden">
          {loading && (
            <div className="px-3 py-2 text-sm text-gray-500">Loading...</div>
          )}
          {suggestions.map((sug) => (
            <div
              key={sug.properties.place_id}
              onClick={() => handleSelect(sug)}
              className="cursor-pointer w-full text-left px-3 py-2 hover:bg-gray-100 transition-colors"
            >
              <div className="block text-sm font-medium text-black">
                {sug.properties.name ||
                  sug.properties.address_line1 ||
                  sug.properties.city}
              </div>
              <div className="block text-sm text-gray-600">
                {sug.properties.formatted}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}